/** @jsx jsx */
import { Link } from '@bottlebooks/gatsby-theme-base/src';
import BaseLogo from '@bottlebooks/gatsby-theme-event/src/components/Layout/Logo';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-plugin-sanity-image';
import { jsx } from 'theme-ui';

/**
 *
 * @param {object} props
 * @param {string } [props.to]
 * @param {boolean} [props.isScrolledDown]
 * @returns
 */
export default function Logo({ to, isScrolledDown, ...rest }) {
  const result = useStaticQuery(query);
  const collectionId = result?.collection?.collectionId;
  const sites = result?.allSanitySite?.nodes;
  const site = sites?.find((site) => site.collectionId === collectionId);
  if (!site)
    return <BaseLogo to={to} isScrollDown={isScrolledDown} {...rest} />;
  const { logo, name } = site || {};
  if (!logo) return null;
  if (!to) return <LogoImage logo={logo} alt={name} />;
  return (
    // On logos, it's allowed to use external links on 'to' (to possibly link to a main website).
    // The Link component takes care of that. We need to suppress the warning though.
    <Link to={to} _suppressExternalLinkWarning {...rest}>
      <LogoImage logo={logo} alt={name} />
    </Link>
  );
}

function LogoImage({ logo, alt, ...rest }) {
  return (
    <Image
      {...logo}
      width={60}
      // height={Array.isArray(height) ? height[height.length - 1] : height} // TODO height doesn't work due to a bug in sanity/image-url upstream library: https://github.com/sanity-io/image-url/issues/32
      // alt={brand.name}
      sizes={`(max-width: 40em) 60px`}
      alt={alt}
      sx={{
        objectFit: 'contain',
        // Always ensure the images are full-width
        // width: 60,
        height: 40,
        borderRadius: 'default',
      }}
      {...rest}
    />
  );
}

const query = graphql`
  {
    collection: event {
      collectionId: eventId
    }
    allSanitySite {
      nodes {
        collectionId
        logo {
          ...ImageWithPreview
        }
        name
      }
    }
  }
`;
